export default {
  title: "Notifiche",
  viewAll: "Visualizza tutte",
  markAsRead: "Segna come letta",
  markAllAsRead: "Segna tutte come lette",
  noNotifications: "Nessuna notifica",
  types: {
    info: "Informazione",
    warning: "Avvertimento",
    error: "Errore",
    success: "Successo"
  },
  actions: {
    view: "Visualizza",
    dismiss: "Ignora",
    accept: "Accetta",
    decline: "Rifiuta"
  },
  categories: {
    system: "Sistema",
    tasks: "Attività",
    guests: "Ospiti",
    budget: "Budget",
    vendors: "Fornitori",
    timeline: "Pianificazione",
    achievements: "Successo",
    weddingWebsite: "Sito Web Matrimonio"
  },
  settings: {
    title: "Impostazioni notifiche",
    push: {
      title: "Notifiche push",
      description: "Ricevi notifiche anche senza utilizzare l'app"
    },
    categories: {
      title: "Categorie di notifica"
    },
    other: {
      title: "Altre notifiche",
      email: {
        title: "Notifiche email",
        description: "Ricevi aggiornamenti importanti via email"
      },
      desktop: {
        title: "Notifiche desktop",
        description: "Ricevi notifiche sul tuo computer"
      }
    },
    testButton: "Testa le notifiche"
  },
  errors: {
    loadPreferences: "Errore durante il caricamento delle preferenze",
    pushToggle: "Errore durante la modifica delle notifiche push",
    categoryToggle: "Errore durante la modifica delle categorie"
  }
};
